import { render, staticRenderFns } from "./deleteClassify.vue?vue&type=template&id=7bd09d7c&"
import script from "./deleteClassify.vue?vue&type=script&lang=js&"
export * from "./deleteClassify.vue?vue&type=script&lang=js&"
import style0 from "./deleteClassify.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports